import styled from '@emotion/styled';
import { Modal } from 'react-bootstrap';

const CustomModal = styled(Modal)`
  background-color: #0000004b;
  backdrop-filter: blur(2px);
  & .modal-dialog {
    margin-right: auto;
    /* max-width: fit-content; */
    margin-left: auto;
  }
  & .modal-header .btn-close {
    background-color: #ffffff39;
  }
`;

export default CustomModal;
